/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusNewsDetailDto } from '../../models/lexplus-news-detail-dto';

export interface NewsControllerFindOneDetailsByIdV1$Params {
  id: number;
}

export function newsControllerFindOneDetailsByIdV1(http: HttpClient, rootUrl: string, params: NewsControllerFindOneDetailsByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusNewsDetailDto>> {
  const rb = new RequestBuilder(rootUrl, newsControllerFindOneDetailsByIdV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusNewsDetailDto>;
    })
  );
}

newsControllerFindOneDetailsByIdV1.PATH = '/v1/news/details/{id}';
